var _style, _polygon, _polygon2, _polygon3, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    zoomAndPan: "disable",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\tline {\r\n\t\t\tstroke: rgba(255,255,255,0.45);\r\n\t\t\tstroke-width: 0.5px;\r\n\t\t}\r\n\t\tpolygon.one {\r\n\t\t\tfill: rgba(255,255,255,0.225);\r\n\t\t}\r\n\t\tpolygon.two {\r\n\t\t\tfill: rgba(255,255,255,0.15);\r\n\t\t}\r\n\t\tpolygon.three {\r\n\t\t\tfill: rgba(255,255,255,0.075);\r\n\t\t}\r\n\t")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "one",
    points: "-350,0 650,1000 0,1000 0,0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "two",
    points: "0,0 1000,1000 0,1000 0,0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "three",
    points: "350,0 1350,1000 0,1000 0,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: -350,
    y1: 0,
    x2: 650,
    y2: 1000
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 1000,
    y2: 1000
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 0,
    x2: 1350,
    y2: 1000
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/overlay.7796b1e1d2cae7fd1badbbfbef7142f8.svg";
export { ForwardRef as ReactComponent };